import { DataSourceExecutionEvent } from "@mcleod/components";
import { AutogenLayoutMiscInvoiceProcessingPending } from "./autogen/AutogenLayoutMiscInvoiceProcessingPending";
import { MiscInvoiceProcessingLayout, MiscInvoiceProcessingTableType } from "./MiscInvoiceProcessing";
import { FilterPanel, SecondaryFilterProps } from "@mcleod/dispatch";
import { MiscInvoiceProcessingSecondaryFilter } from "./MiscInvoiceProcessingSecondaryFilter";

export class MiscInvoiceProcessingPending extends AutogenLayoutMiscInvoiceProcessingPending implements MiscInvoiceProcessingLayout {
    public type: MiscInvoiceProcessingTableType;
    private filterPanel: FilterPanel;
    private _refreshTabsCallback?: () => void;

    public secondaryFilters: SecondaryFilterProps[] = [
        MiscInvoiceProcessingSecondaryFilter.FILTER_RECURRING,
        MiscInvoiceProcessingSecondaryFilter.FILTER_NON_RECURRING
    ];

    override onLoad() {
        this.filterPanel = new FilterPanel(this.secondaryFilters, this.tableMiscInvoice, this.panelSecondaryFilters);
        this.filterPanel.syncFilterVisibility(null);
    }

    set refreshTabsCallback(callback: () => void) {
        this._refreshTabsCallback = callback;
    }

    get refreshTabsCallback(): (() => void) | undefined {
        return this._refreshTabsCallback;
    }

    sourceMiscBillBeforeExecution(event: DataSourceExecutionEvent) {
        event.filter.ready_to_process = "N";
        event.filter.end_date = ">=t|="; // end_date is on or after today, or end_date is null
    }
}
